module.exports = __webpack_public_path__ + "static/media/work-img6.4fb5ab64.jpg";